import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import './alert.less'
import { setDocumentTitle, setUidToken  } from 'src/helper/tool'
import brower from 'src/helper/brower'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'
import { zonets, todayts, lastmonthts, thismonthts, nextmonthts } from 'src/helper/time'
import lang from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import localstorage from 'src/helper/localstorage'
import { unix2date } from 'src/helper/time'

@inject('store')
@observer
export default class extends React.Component {

  state = {
    lang: lang.en,
    sendman: '',
    sendgold: 0,
    itemIndex: -1,
    dollar: 0,
    preLoad: true,
    loading: false,
    alert: {
      display: false,
      title: ''
    },
    dialog: {
      display: false,
      title: '',
    }
  }

  constructor(props) {
    super(props)
    this.agentgoldStore = this.props.store.register('app/agentgold')
  }


  async componentWillMount() {
    // ()
    let {language} = this.props.location.query
    language =await getlang(language)
    console.log("language", language)
    if (language!='en' && language!='ar') {
      language='en'
    }
    this.setState({
      lang: setlang(language,lang),
      language:language,
    })

      let uid = await setUidToken(this.props.location.query)
      await this.RunOnStart(uid)
  }

  //需要uid才能执行的操作
  RunOnStart = async (uid) => {
    this.loadInit()

    this.setState({
      sendgold: this.agentgoldStore.data.goldList[0].gold,
      itemIndex: 0,
      dollar: this.agentgoldStore.data.goldList[0].price * 100
    })

    // console.log("uid aaaaa", uid)
    await this.agentgoldStore.setUid(uid)
    this.agentgoldStore.MyAccountInfo()

    this.setState({
      preLoad: false
    })
  }

  async componentDidMount() {
    setDocumentTitle(this.state.lang.title)
  }

  onChange1(event) {
    this.setState({ sendman: event.target.value })
  }

  onChange2(event) {
    this.setState({ sendgold: event.target.value })
  }

  selectGold = (index, gold, price) => {
    this.setState({ sendgold: gold, itemIndex: index, dollar: price * 100 })
  }

  loadInit = () => {
    this.setState({
      loading: false,
      alert: {
        display: false,
        title: ''
      },
      dialog: {
        display: false,
        title: '',
        cancel: this.state.lang.cancel || '',
        sure: this.state.lang.comment
      }
    })
  }

  rechange = async () => {
    this.agentgoldStore.dataInit()

    let uid = this.senduid.value
    let val = parseInt(this.state.sendgold)

    if (uid == '') {
      this.setState({
        alert: {
          display: true,
          title: this.state.lang.recuid
        },
        loading: true
      })
      this.senduid.focus()
      return
    }

    if (!!(val > 0) == false) {
      this.setState({
        alert: {
          display: true,
          title: this.state.lang.goldnum
        },
        loading: true
      })
      this.sendgold.focus()
      return
    }

    if (val > this.agentgoldStore.data.nowgold || this.agentgoldStore.data.nowgold == 0) {
      this.setState({
        alert: {
          display: true,
          title: this.state.lang.nogold
        },
        loading: true
      })
      this.sendgold.focus()
      return
    }

    let map = {
      duid: uid+''
    }

    let d = await http.post('/web/GetUserInfoWeb', map)
    this.agentgoldStore.setRecUid(d)

    this.setState({
      dialog: {
        display: true,
        title: '',
        cancel: this.state.lang.cancel || '',
        sure: this.state.lang.comment
      },
      loading: true
    })
  }

  sureRechange = async (uid) => {
    this.loadInit()

    this.setState({
      loading: true
    })

    let map = {
      uid: parseInt(uid),
      val: parseInt(this.state.sendgold),
      dollar: parseInt(this.state.dollar)
    }
    if (map.uid > 0 && map.val > 0) {
      let d = await http.post('/web/AgentGold', map)
      this.AgentGoldRes(d)
    }
  }

  AgentGoldRes = async (d) => {
    // this.setState({
    //   sendman: 0
    // })

    if (d.code == 0) {
      this.setState({
        alert: {
          display: true,
          title: this.state.lang.sendsuccess
        },
        loading: true
      })
    } else {
      this.setState({
        alert: {
          display: true,
          title: d.msg
        },
        loading: true
      })
    }
    this.agentgoldStore.MyAccountInfo()
  }

  list = () => {
    let { list } = this.agentgoldStore.data
    return (
      list &&
      list.map((item, index) => {
        return (
          <div key={index} className={`${'item item_bg' + ((index % 2) + 1)}`}>
            <div className="sendtime">{unix2date(item.ts)}</div>
            <div className="remark">{item.duid}</div>
            <div className="val">{item.gold}</div>
          </div>
        )
      })
    )
  }

  goldList = () => {
    let i = this.state.itemIndex
    return (
      <div className="goldList">
        {this.agentgoldStore.data.goldList.map((item, index) => {
          return (
            <div
              className={`item ${i == index ? 'act' : ''}`}
              onClick={this.selectGold.bind(this, index, item.gold, item.price)}
            >
              <div className="gold">{item.gold || 0}</div>
              <div className="price">${item.price || 0}</div>
            </div>
          )
        })}
      </div>
    )
  }

  render() {
    let { sendman, nowgold, tag, user } = this.agentgoldStore.data
    if (tag == 2) {
      return (
        <div className="agentgold">
          {/* 顶部 */}
          <div className="head">
            <div className="left"></div>
            <div className="title">{this.state.lang.title2}</div>
            <div
              className="record"
              onClick={() => {
                this.agentgoldStore.setTag(1)
              }}
            >
              {this.state.lang.sendbtn}
            </div>
          </div>
          <div className="list">
            <div className={`${'item item_bg2'}`}>
              <div className="sendtime">{this.state.lang.ts}</div>
              <div className="remark">{this.state.lang.senduser}</div>
              <div className="val">{this.state.lang.sendnum}</div>
            </div>
            {this.list()}
          </div>
        </div>
      )
    } else {
      return (
        <div className="agentgold">
          {/* 顶部 */}
          <div className="head">
            <div className="left"></div>
            <div className="title">{this.state.lang.title}</div>
            <div
              className="record"
              onClick={() => {
                this.agentgoldStore.setTag(2)
              }}
            >
              {this.state.lang.record}
            </div>
          </div>
          {/* 金币 */}
          <div className="nowgold">
            {this.state.lang.nowgold}
            <span className="gold">{nowgold}</span>
          </div>
          {/* 赠送账号 */}
          <div className="pleaseinput">{this.state.lang.pleaseinput}</div>
          {/* 赠送金额 */}
          <div className="senduid">
            <div className="inputText">
              <input
                ref={(node) => (this.senduid = node)}
                value={this.state.sendman}
                onChange={this.onChange1.bind(this)}
              />
            </div>
          </div>
          <div className="pleaseinputgolds">{this.state.lang.pleaseinputgolds}</div>

          {/* 发送按钮 */}
          {this.goldList()}
          {/* <div className='sendgold'>
            <div className="inputText">
              <input ref={node => this.sendgold = node} maxLength="9" value={this.state.sendgold} onChange={this.onChange2.bind(this)} />
            </div>
          </div> */}

          <div
            className={`submit ${this.state.clickBtn && 'active'}`}
            onClick={() => {
              this.rechange()
            }}
          >
            {this.state.lang.sure}
          </div>

          {this.state.alert.display && (
            <div className="alert">
              {this.state.alert.title}
              <div
                className="submit"
                onClick={() => {
                  this.loadInit()
                }}
              >
                {this.state.lang.comment}
              </div>
            </div>
          )}
          {this.state.dialog.display && (
            <div className="dialog">
              <div className="sendman">
                <div className="avatarurl">
                  <img src={cdn(sendman.avatarurl)} />
                </div>
                <div className="nickname">{sendman.nickname}</div>
              </div>

              {sendman.uid == -1 && (
                <div>
                  <div className="title"></div>
                  <div className="btn">
                    <div
                      className="sure"
                      onClick={() => {
                        this.loadInit()
                      }}
                    >
                      Ok
                    </div>
                  </div>
                </div>
              )}

              {sendman.uid == 0 && (
                <div>
                  <div className="title">{this.state.lang.nouser}</div>
                  <div className="btn">
                    <div
                      className="sure"
                      onClick={() => {
                        this.loadInit()
                      }}
                    >
                      Ok
                    </div>
                  </div>
                </div>
              )}

              {sendman.uid > 0 && sendman.agent != 1 && (
                <div>
                  <div className="title">
                    {this.state.lang.madesure.replace('AAA', sendman.duid).replace('BBB', this.state.sendgold)}
                  </div>
                  <div className="btn">
                    <div
                      className="cancel"
                      onClick={() => {
                        this.loadInit()
                      }}
                    >
                      {this.state.dialog.cancel || ''}
                    </div>
                    <div
                      className="sure"
                      onClick={() => {
                        this.sureRechange(sendman.uid)
                      }}
                    >
                      {this.state.dialog.sure}
                    </div>
                  </div>
                </div>
              )}

              {sendman.uid > 0 && sendman.agent == 1 && (
                <div>
                  <div className="title">
                    {this.state.lang.cannot.replace('AAA', sendman.duid).replace('BBB', this.state.sendgold)}
                  </div>
                  <div className="btn">
                    <div
                      className="cancel"
                      onClick={() => {
                        this.loadInit()
                      }}
                    >
                      {this.state.lang.cancel || ''}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
          {(this.state.loading || this.state.preLoad) && (
            <div className="loading">
              <img src="https://img.chatie.live/app/source/loading.gif" />
            </div>
          )}
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// src/pages/app/agentgold/index.js